/* The two thumbs under the summary (R47): neutral raised controls; the chosen one takes the ink. */
.feedback {
  display: flex;
  gap: var(--space-2);
}

.thumb {
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  padding: var(--space-0);
  color: var(--text-2);
  cursor: pointer;
  background: var(--buddy-raised);
  border: var(--border-hairline) solid var(--border-2);
  border-radius: var(--radius-sm);
  box-shadow: var(--shadow-buddy-control);
}

.thumb:focus-visible {
  outline: var(--border-focus) solid var(--focus);
  outline-offset: var(--space-2px);
}

.thumbOn {
  color: var(--bg);
  background: var(--text);
  border-color: var(--text);
}

.thumbGlyph {
  width: 15px;
  height: 15px;
}

.thumbDown {
  transform: rotate(180deg);
}

/* The optional comment (R47), offered once a thumb is chosen: one quiet line under the thumbs. */
.comment {
  display: flex;
  gap: var(--space-2);
  align-items: center;
  max-width: 520px;
}

.commentField {
  flex: 1;
  min-width: 0;
  height: 32px;
  padding: var(--space-0) var(--space-3);
  font-family: var(--font-body);
  font-size: var(--fs-note);
  color: var(--text);
  background: var(--buddy-raised);
  border: var(--border-hairline) solid var(--border-2);
  border-radius: var(--radius-sm);
}

.commentField::placeholder {
  color: var(--text-2);
}

.commentField:focus-visible {
  outline: var(--border-focus) solid var(--focus);
  outline-offset: var(--space-2px);
}

.thanks {
  margin: var(--space-0);
  font-size: var(--fs-note);
  font-weight: var(--fw-semibold);
  color: var(--text-2);
}
